<!--线路图-->
<template>
  <div class="tw-xlt">
    <div class="tw-xlt-head">
      <div class="tw-xlt-head-title">地图查看</div>
      <van-icon
        name="arrow-left"
        size="17"
        color="#33639e"
        @click="handleBackClick"
        class="tw-xlt-head-icon"
      />
      <van-icon
        name="replay"
        size="17"
        class="head-rightcon"
        color="#33639e"
        @click="handleRefreshClick"
      />
    </div>
    <div id="tw-xlt-map"></div>
    <div class="tw-xlt-bottom">
      <div class="tw-xlt-bottom-top">
        <div class="tw-xlt-bottom-top-station">
          <img
            src="../assets/image/station.png"
            alt=""
            class="tw-xlt-bottom-top-img"
          />
          <div class="tw-xlt-bottom-top-text">{{ $route.query.station }}</div>
        </div>
        <div
          class="tw-xlt-bottom-top-info"
          v-if="
            busInfoList.is_now == 'true' &&
              carLocationList.length != 0 &&
              carLocationList != null
          "
        >
          <div class="tw-xlt-bottom-top-info-cp">
            车牌:&nbsp;{{ carLocationList[0].vehi_num }}
          </div>
          <div class="tw-xlt-bottom-top-info-cp">
            车速:&nbsp;{{ carLocationList[0].speed }}km/h
          </div>
          <div class="tw-xlt-bottom-top-info-cp">
            <van-icon name="location-o"></van-icon>
            :&nbsp;{{ formatTime(carLocationList[0].speed_time) }}
          </div>
          <div class="tw-xlt-bottom-top-info-cp">
            {{ formatIsOnline(carLocationList[0].online_state) }}
          </div>
        </div>
        <div
          class="tw-xlt-bottom-top-info"
          v-else
          style="text-align:center; font-weight: 550;line-height:70px"
        >
          暂无班车信息
        </div>
      </div>
      <div
        class="tw-xlt-bottom-bot"
        v-if="
          carLocationList != null &&
            carLocationList.length != 0 &&
            parseInt(carLocationList[0].near_distance) > 0
        "
      >
        <div class="tw-xlt-bottom-bot-left">
          {{ carLocationList[0].near_distance }}站
        </div>
        <div class="tw-xlt-bottom-bot-right">
          {{ carLocationList[0].about_minute }}分钟
        </div>
      </div>
      <div
        v-else-if="carLocationList != null && carLocationList.length != 0"
        class="tw-xlt-bottom-bot1"
      >
        已过站
      </div>
      <div
        v-else-if="carLocationList == null || carLocationList.length == 0"
        class="tw-xlt-bottom-bot1"
      >
        暂未发车
      </div>
    </div>
    <div class="tw-hide">
      <div class="tw-map-dialog-wrapper" ref="map-dialog">
        <div class="tw-title">{{ mapDialogData.vehi_num }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'underscore'
import moment from 'moment'
import { getBcStationList, getLineGps, getRunBus } from 'api/RouteDetailsAPI'
import { getBcByStationName } from 'api/indexAPI'
import { Toast } from 'vant'

export default {
  name: 'CircuitDiagram',
  data() {
    return {
      map: null,
      position: {},
      busStationList: {},
      lineList: [],
      busInfoList: [],
      carLocationList: [],
      mapDialogData: {},
      timer: null
    }
  },
  mounted() {
    this.initMap()
    this.getBcByStationNameInter()
  },
  methods: {
    handleBackClick() {
      this.$router.push({
        path: '/zdxl/xlxq',
        query: {
          bid: this.$route.query.bid,
          near: this.$route.query.near,
          station: this.$route.query.station,
          sno: this.$route.query.sno
        }
      })
    },
    //初始化地图
    initMap() {
      this.map = new AMap.Map('tw-xlt-map', {
        mapStyle: 'amap://styles/fresh',
        resizeEnable: true,
        zoom: 13
        // center: []
      })
      let _self = this
      if (this.$store.state.position.lat !== undefined) {
        this.position = this.$store.state.position
        this.getBcByStationName()
        return
      }
      AMap.plugin('AMap.Geolocation', function() {
        var geolocation = new AMap.Geolocation({
          enableHighAccuracy: true, //是否使用高精度定位，默认:true
          timeout: 10000, //超过10秒后停止定位，默认：5s
          buttonPosition: 'RB', //定位按钮的停靠位置
          buttonOffset: new AMap.Pixel(10, 20), //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
          zoomToAccuracy: true //定位成功后是否自动调整地图视野到定位点
        })
        _self.map.addControl(geolocation)
        geolocation.getCurrentPosition(function(status, result) {
          if (status == 'complete') {
            this.getBcByStationName()
            // onComplete(result);
          } else {
            // onError(result);
          }
        })
      })
    },
    //根据站点名称获取途经班车信息
    getBcByStationName() {
      const { bid, sno } = this.$route.query
      const params = new URLSearchParams()
      params.append('bid', bid)
      params.append('stationName', sno)
      getBcByStationName(params).then(res => {
        this.busInfoList = res.data.data[0]
        // console.info('this.busInfoList', this.busInfoList)
        if (
          res.data.data[0].runBusInfo != null &&
          res.data.data[0].runBusInfo.length != 0
        )
          this.carLocationList = res.data.data[0].runBusInfo

        this.getBcStationList()
      })
    },
    getBcByStationNameInter() {
      this.timer = setInterval(() => {
        const { bid, sno } = this.$route.query
        const params = new URLSearchParams()
        params.append('bid', bid)
        params.append('stationName', sno)
        getBcByStationName(params).then(res => {
          this.busInfoList = res.data.data[0]
          if (
            res.data.data[0].runBusInfo != null &&
            res.data.data[0].runBusInfo.length != 0
          )
            this.carLocationList = res.data.data[0].runBusInfo
        })
      }, 10000)
    },
    //获取班车站点集合
    getBcStationList() {
      const params = new URLSearchParams()
      params.append('bid', this.$route.query.bid)
      getBcStationList(params).then(res => {
        if (res.data.success == true) {
          this.busStationList = res.data.data
          this.getLineGps()
        }
      })
    },
    //获取班车经纬度点集合
    getLineGps() {
      this.lineList = []
      const params = new URLSearchParams()
      params.append('bid', this.$route.query.bid)
      getLineGps(params).then(res => {
        if (res.data.success == true) {
          if (
            res.data.data.length == 0 ||
            res.data.data[0].line_coords == null ||
            res.data.data[0].line_coords == ''
          ) {
            // Toast('无线路信息')
          } else {
            var list = res.data.data[0].line_coords.split(';')
            // console.info('list', list)
            _.each(list, item => {
              this.lineList.push([
                parseFloat(item.split(',')[0]),
                parseFloat(item.split(',')[1])
              ])
            })
          }
        }
        this.addStation()
        // this.addPolyLine()
        this.addCarLocation()
      })
    },
    //添加站点
    addStation() {
      this.map.clearMap()
      const _self = this
      var lnglats = [] //站点经纬度集合
      var siteNameLsit = [] //站点名集合
      for (let i = 0; i < this.busStationList.length; i++) {
        lnglats.push([
          this.busStationList[i].station_long,
          this.busStationList[i].station_lat
        ])
        siteNameLsit.push([this.busStationList[i].station_alias])
      }
      for (let i = 0, marker; i < lnglats.length; i++) {
        if (i == 0) {
          var icon = new AMap.Icon({
            image: require('../assets/image/start.png'),
            imageSize: new AMap.Size(35, 35),
            size: new AMap.Size(35, 35)
          })
          const marker = new AMap.Marker({
            icon: icon,
            position: lnglats[i],
            map: this.map,
            data: this.busStationList[i]
          })
          const markerClick = e => {
            this.$router.push({
              path: '/zdxl/xlxq/xlt',
              query: {
                bid: this.$route.query.bid,
                near: this.$route.query.near,
                station: marker.w.data.station_alias,
                sno: marker.w.data.station_alias_no
              }
            })
            this.getBcByStationName()
          }
          marker.on('click', markerClick)
        } else if (i == siteNameLsit.length - 1) {
          var icon = new AMap.Icon({
            image: require('../assets/image/end.png'),
            imageSize: new AMap.Size(35, 35),
            size: new AMap.Size(35, 35)
          })
          const marker = new AMap.Marker({
            icon: icon,
            position: lnglats[i],
            map: this.map,
            data: this.busStationList[i]
          })
          const markerClick = e => {
            this.$router.push({
              path: '/zdxl/xlxq/xlt',
              query: {
                bid: this.$route.query.bid,
                near: this.$route.query.near,
                station: marker.w.data.station_alias,
                sno: marker.w.data.station_alias_no
              }
            })
            this.getBcByStationName()
          }
          marker.on('click', markerClick)
        } else if (siteNameLsit[i] == this.$route.query.station) {
          var icon = new AMap.Icon({
            image: require('../assets/image/dqzd.png'),
            imageSize: new AMap.Size(30, 30),
            size: new AMap.Size(30, 30)
          })
          marker = new AMap.Marker({
            icon: icon,
            position: lnglats[i],
            map: _self.map,
            data: this.busStationList[i],
            offset: new AMap.Pixel(-15, -30)
          })
          const markerClick = e => {
            this.$router.push({
              path: '/zdxl/xlxq/xlt',
              query: {
                bid: this.$route.query.bid,
                near: this.$route.query.near,
                station: marker.w.data.station_alias,
                sno: marker.w.data.station_alias_no
              }
            })
            this.getBcByStationName()
          }
          marker.on('click', markerClick)
        } else {
          var icon = new AMap.Icon({
            image: require('../assets/image/yq.png'),
            imageSize: new AMap.Size(15, 15),
            size: new AMap.Size(15, 15)
          })
          const marker = new AMap.Marker({
            icon: icon,
            position: lnglats[i],
            map: this.map,
            data: this.busStationList[i]
          })
          const markerClick = e => {
            this.$router.push({
              path: '/zdxl/xlxq/xlt',
              query: {
                bid: this.$route.query.bid,
                near: this.$route.query.near,
                station: marker.w.data.station_alias,
                sno: marker.w.data.station_alias_no
              }
            })
            this.getBcByStationName()
          }
          marker.on('click', markerClick)
        }
      }

      // 缩放地图到合适的视野级别
      this.map.setFitView()
    },
    //画线
    addPolyLine() {
      if (
        this.lineList[0] == NaN ||
        this.lineList[1] == NaN ||
        this.lineList[0] == undefined ||
        this.lineList[1] == undefined
      )
        return
      let _self = this
      var polyline = new AMap.Polyline({
        path: _self.lineList,
        showDir: true,
        strokeColor: '#28F', //线颜色
        // strokeOpacity: 1,     //线透明度
        strokeWeight: 6 //线宽
        // strokeStyle: "solid"  //线样式
      })
      _self.map.add(polyline)
      polyline.setMap(_self.map)
    },
    //车辆位置
    addCarLocation() {
      let _self = this
      // console.info('this.busInfoList.is_now ', this.busInfoList.is_now)
      if (this.busInfoList.is_now == 'false') return
      // console.info('12121', this.carLocationList)
      for (let i = 0; i < this.carLocationList.length; i++) {
        // console.info(' this.carLocationList', this.carLocationList)
        var infoWindow = new AMap.InfoWindow({
          position: [_self.carLocationList[i].px, _self.carLocationList[i].py],
          offset: new AMap.Pixel(0, -30),
          content: this.$refs['map-dialog']
        })
        infoWindow.open(this.map)
        var icon = new AMap.Icon({
          image: require('../assets/image/station1.png'),
          imageSize: new AMap.Size(35, 35),
          size: new AMap.Size(35, 35)
          // offset: new AMap.Pixel(-20, -20)
        })
        var marker = new AMap.Marker({
          icon: icon,
          position: [_self.carLocationList[i].px, _self.carLocationList[i].py],
          map: _self.map,
          data: _self.carLocationList[i]
        })
        const markerClick = e => {
          // infoWindow.setContent(e.target.content)
          infoWindow.open(_self.map, e.target.getPosition())
          this.mapDialogData = marker.w.data
        }

        marker.on('click', markerClick)
        marker.emit('click', { target: marker })
      }
    },
    //刷新
    handleRefreshClick() {
      location.reload()
    },
    //格式化时间
    formatTime(data) {
      return moment(data).format('YYYY-MM-DD HH:mm:ss')
    },
    //判断在线离线
    formatIsOnline(data) {
      return data && data == 1 ? '在线' : '离线'
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
    this.timer = null
  }
}
</script>

<style lang="scss" soped>
#tw-xlt-map {
  height: 92.9%;
}
.tw-xlt {
  height: 100%;
  &-head {
    height: 7%;
    background-color: #fff;
    position: relative;
    border-bottom: 1px solid #ebeced;
    &-title {
      // text-align: center;
      font-size: 15px;
      font-weight: 700;
      letter-spacing: 1px;
      padding-top: 5%;
      padding-left: 10%;
      color: #33639e;
      box-sizing: border-box;
    }
    &-icon {
      position: absolute;
      left: 2%;
      top: 30%;
    }
  }
  &-bottom {
    position: absolute;
    height: 150px;
    width: 90%;
    background-color: #ffffff;
    left: 5%;
    bottom: 10px;
    z-index: 161;
    &-top {
      width: 100%;
      height: calc(100% - 40px);
      border-bottom: 1px solid #dcdcdc;
      // display: flex;
      &-station {
        width: 100%;
        height: 40px;
        display: flex;
      }
      &-img {
        padding-top: 10px;
        padding-left: 10px;
        width: 20px;
        height: 20px;
      }
      &-text {
        height: 40px;
        line-height: 40px;
        margin-left: 10px;
        font-weight: 600;
      }
      &-info {
        height: calc(100% - 40px);
        width: 100%;
        &-cp {
          padding-left: 15px;
          // height: 30px;
          line-height: 17px;
        }
      }
    }
    &-bot {
      width: 100%;
      height: 40px;
      display: flex;
      &-left {
        width: 50%;
        height: 40px;
        line-height: 40px;
        border-right: 1px solid #dcdcdc;
        text-align: center;
        font-weight: 600;
      }
      &-right {
        width: calc(50% - 1px);
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-weight: 600;
      }
    }
    &-bot1 {
      height: 40px;
      line-height: 40px;
      text-align: center;
      font-weight: 600;
    }
  }
}
.head-rightcon {
  position: absolute;
  right: 2%;
  top: 30%;
}
.tw-hide {
  display: none;
}
</style>
